import LocalizedStrings from 'react-localization';

const strings = new LocalizedStrings({
  en: {
    liveMode: {
      text: {
        attention:
          'Attention. You are now working with and updating Live environment configuration. Please proceed with caution',
        prodMode: 'You have switched to Live mode',
        sandboxMode: 'You have switched to Sandbox mode',
      },
    },
    header: {
      buttons: {
        signIn: 'Sign In',
        signUp: 'Sign Up',
      },
      text: {
        docsLink: 'Docs',
        ghost: 'Ghost',
        guides: 'Guides',
        apis: "API",
        sdks: "SDK",
        getStartedLink: 'Get started',
        apisLink: 'API{0}',
        sdksLink: 'SDK{0}',
        appsLink: 'Apps',
        supportLink: 'Support',
        mainPageLink: 'Staq.io',
        more: 'More',
        logoutLink: 'Logout',
        lightMode: 'Light mode',
        darkMode: 'Dark mode',
        profileLink: 'Profile',
        certificateLink: 'Certificates',
        prodMode: 'Live mode',
        sandBoxMode: 'Sandbox mode',
      },
    },
    appList: {
      errors: {
        retrievingApp: 'Error retrieving app list. Contact Customer support.',
        creatingApp: 'Error creating app. ',
        creatingAppException: 'Error creating app. Contact Customer support.',
      },
      fields: {
        appName: 'App name',
      },
      buttons: {
        createNew: 'Create new App',
        cancel: 'Cancel',
        create: 'Create app',
      },
      text: {
        title: 'My Apps',
        modalCreateAppTitle: 'Create new app',
        noApps: 'You don’t have any apps yet.',
        createFirstApp: 'Create your first app now.',
      },
    },
    appCard: {
      text: {
        noDescription: 'No Description',
        created: 'Created',
        apis: 'APIs - ',
        appApis: 'App APIs',
        partnerPrepaidCardsApi: 'Partner Prepaid Cards API',
        partnerAccountsAPI: 'Partner Accounts API',
      },
    },
    appSpace: {
      buttons: {
        back: 'Back',
      },
      text: {
        title: 'Settings',
        credentials: 'Credentials',
        permissions: 'Permissions',
        webhooks: 'Webhooks',
      },
    },
    appPermissions: {
      errors: {
        savingPermissions: 'Permissions change error. Contact Customer support.',
      },
      text: {
        title: 'Permissions',
        saved: 'Permissions saved',
        apisTitle: 'APIs',
        apisDescription:
          'Defines the APIs this app is allowed to call. Detailed API information can be found at our {0}',
        apiDocLink: 'API doc section.',
        apisListTitle: 'CHOOSE APIs',
      },
    },
    appCredentials: {
      errors: {
        updatingDescription: 'Error update description. ',
        updatingException: 'Error update description. Contact Customer support.',
        regeneratingSecret: 'Error regenerateSecret. Contact Customer support.',
      },
      fields: {
        appName: 'App name',
        description: 'App description',
        clientId: 'Client ID',
        clientSecret: 'Client Secret',
      },
      buttons: {
        generate: 'Generate',
        cancel: 'Cancel',
        delete: 'Delete app',
        save: 'Save',
      },
      text: {
        title: 'Credentials',
        modalNewSecretTitle: 'Generate new secret for this App',
        successSaving: 'Description has been saved successfully',
        descriptionPlaceholder:
          'Leave a short description of your app. It will be visible in app list.',
        appCredentialsTitle: 'App credentials',
        publicClientTitle: 'OAuth public client',
        appCredentialsDescription:
          "These credentials allow your app to access staq API. They are secret. Please don't share your app credentials with anyone, include them in public code repositories, or store them in insecure ways. You'll need client ID when making your oauth.auth request.",
        publicClientDescription: 'This client Id is used for OAuth Authorization Code Grant Flow.',
        dangerZone: 'Danger zone',
        deleteTitle: 'Delete this app',
        deleteDescription:
          'Once you delete an app, there is no going back. Please be certain before proceeding.',
        copied: 'Copied to clipboard',
      },
    },
    appWebhooks: {
      errors: {
        gettingException: 'Error loading webhooks. Contact Customer support.',
        creatingException: 'Error creating webhook. Contact Customer support.',
        urlUsedException: 'Endpoint is already in use. Please specify different URL.',
        gettingEventTypesException: 'Error loading event types. Contact Customer support.',
        partnerBlockedException: "Webhook can't be registered for the blocked application.",
      },
      buttons: {
        create: 'Create webhook',
        cancel: 'Cancel',
        createNew: 'Create new Webhook',
      },
      text: {
        noWebhooks: 'You don’t have any webhooks yet.',
        titleCreate: 'Create new webhook',
        created: 'Webhook has been created successfully',
      },
      fields: {
        newUrl: 'URL',
        newEventType: 'Event Type',
      },
    },
    appWebhookDetails: {
      errors: {
        gettingException: 'Error loading webhook. Contact Customer support.',
        gettingSecretsException: 'Error loading webhook secrets. Contact Customer support.',
        updatingException: 'Error updating webhook. Contact Customer support.',
        pausingResumingException: 'Error pausing/resuming webhook. Contact Customer support.',
        generatingSecret: 'Error generating secret. Contact Customer support.',
        deletingException: 'Error deleting webhook. Contact Customer support.',
        urlUsedException: 'Endpoint is already in use. Please specify different URL.',
        deletingCertificateException:
          'Error deleting webhook certificate. Contact Customer support.',
        savingCertificate: 'Error saving certificate: {0}',
        retrievingException: 'Error retrieving webhook certificates',
        testingException: 'Error testing webhook. Contact Customer support.',
        notSuccessTest: 'Test message delivery failed',
        certRequiredForTest: 'Valid webhook certificate is required',
      },
      buttons: {
        pause: 'Pause',
        resume: 'Resume',
        save: 'save',
        delete: 'Delete webhook',
        generate: 'Generate',
        cancel: 'Cancel',
        upload: 'Upload',
        deleteCertificate: 'Delete',
        test: 'Send test request',
      },
      text: {
        title: 'Webhook Settings',
        secretsTitle: 'Webhook secrets',
        dangerZone: 'Danger zone',
        deleteTitle: 'Delete this webhook',
        deleteDescription:
          'Once you delete a webhook, we will stop preserving notifications for your app. Please be certain before proceeding.',
        secretsDescription:
          "These secrets allow your app to validate digital signature provided by Staq when request is received by your endpoint. They are secret. Please don't share your webhook secrets with anyone, include them in public code repositories, or store them in insecure ways.",
        copied: 'Copied to clipboard',
        modalNewSecretTitle: 'Generate new secret for this webhook?',
        successSaving: 'Webhook has been saved successfully',
        modalDeleteTitle: 'Delete webhook',
        modalDeleteDescription: 'Are you sure you want to delete this webhook?',
        successPause: 'Webhook has been paused successfully',
        successResume: 'Webhook has been resumed successfully',
        successDelete: 'Webhook has been removed successfully',
        successRegenerate: 'Webhook secret successfully renewed',
        certificatesTitle: 'Webhook certificates',
        certificatesDescription:
          'These certificates allow Staq to validate your host when requests is sent to your registered webhook endpoint. Webhook communications requires mTLS connection. You can upload up to 3 certificates that are valid or will be valid in the future.',
        noCertificates: 'No certificates, please upload.',
        uploadTitle: 'Upload',
        uploadDescription: 'File extension must be .cer',
        deleteCertificateTitle: 'Delete certificate',
        deleteCertificateQuestion: 'Delete your webhook certificate',
        deleteCertificateDescription:
          'Once you delete an certificate, there is no going back. Please be certain before proceeding.',
        successCertificateDelete: 'Certificate has been deleted successfully.',
        successUploadCertificate: 'Certificate has been loaded successfully.',
        successTest: 'Test message is added to delivery queue',
      },
      fields: {
        url: 'URL',
        event: 'Event',
        status: 'Status',
        limitedSecret: 'Limited secret',
        webhookSecret: 'Webhook secret',
      },
    },
    appUtils: {
      errors: {
        deletingApp: 'Error delete description. Contact Customer support.',
      },
      fields: {
        appName: 'App name',
      },
      buttons: {
        delete: 'Delete App',
        cancel: 'Cancel',
      },
      text: {
        modelDeleteAppTitle: 'Delete app',
        modelDeleteAppDescription: 'Enter this app name to confirm deletion.',
      },
    },
    support: {
      errors: {
        submittingForm: 'Error submitting support form: ',
        submittingException: 'Error submitting support form',
      },
      fields: {
        firstName: 'First name',
        lastName: 'Last name',
        email: 'Email address',
      },
      buttons: {
        submit: 'submit',
      },
      text: {
        title: 'How can we help?',
        description:
          'Send us an email directly using {0} or alternatively use our contact form below.',
        supportCommentPlaceholder: 'Comment...',
        thankYou: 'Thanks for your message!',
      },
    },
    apiCatalogue: {
      errors: {
        retrievingApiData: 'Error retrieving api data. Contact Customer support.',
      },
      text: {
        title: 'APIs',
        description:
          'Our API Products let you use approved customer data to create or enhance your digital products.',
      },
    },
    profile: {
      errors: {
        retrievingUserProfile: 'Error retrieving user profile. Contact Customer support.',
        emptyNewPassword: 'Only the current password was specified. Please specify new password.',
        savingError: 'Error saving user profile.',
        wrongCurrentPassword: 'Please specify the correct current password.',
        savingException: 'Error saving user profile. Contact Customer support.',
        passwordEmpty: 'Password not defined',
        passwordInvalid: 'Please specify correct new password',
        checking2FA: 'Error retrieving 2FA info. Contact Customer support.',
        disabling2FA: 'Error disabling 2FA. Contact Customer support.',
      },
      fields: {
        userName: 'UserName',
        firstName: 'First name',
        lastName: 'Last name',
        email: 'Email',
        phone: 'Phone Number',
        company: 'Company',
        currentPassword: 'Current Password',
        newPassword: 'New Password',
        otp: 'OTP code',
      },
      buttons: {
        save: 'Save',
        resendOtp: 'Resend',
        cancel: 'Cancel',
        submitOtp: 'Submit',
        changePass: 'Change password',
        enableTwoFactor: 'Add new 2FA device',
        disableTwoFactor: 'Disable two-factor authentication'
      },
      text: {
        title: 'Your details',
        savedProfileAndPassword: 'Profile with new Password has been saved successfully',
        savedProfile: 'Profile has been saved successfully',
        password8charsCheck: 'Password should be at least 8 characters long',
        password64charsCheck: 'Password should not exceed 64 characters',
        passwordLowerCharCheck: 'Password should contain at least one lower case character',
        passwordUpperCharCheck: 'Password should contain at least one upper case character',
        passwordDigitCheck: 'Password should contain at least one digit',
        passwordSpecialCharsCheck: 'Password should contain at least one special character',
        otpModalTitle: 'OTP verification',
        otpModalDescription1:
          'Please enter OTP # {0} to confirm the mobile number change. If you have not received an SMS, then you can resend it.',
        otpModalDescription2: 'Next attempt will be in {0} seconds',
      },
    },
    sessionOutdated: {
      buttons: {
        logout: 'Logout',
        cancel: 'Cancel',
      },
      text: {
        title: 'User session is outdated',
        description: 'Your session must be refreshed to access this functionality',
      },
    },
    prodModeSessionOutdated: {
      buttons: {
        logout: 'Logout',
        change: 'Change mode',
        cancel: 'Cancel',
      },
      text: {
        title: 'Live mode session is outdated',
        description: 'Your session in live mode must be refreshed to access this functionality',
      },
    },
    certificateContainer: {
      errors: {
        revokingException:
          'Certificate cannot be revoked. Unknown error. Please try again later or contact support.',
        retrievingException: 'Error retrieving certificates',
        savingCsr: 'Error saving CSR: {0}',
      },
      buttons: {
        revoke: 'Revoke',
        cancel: 'Cancel',
      },
      text: {
        title: '',
        successUploadCsr: 'CSR loaded successfully.',
        revokeCertificateTitle: 'Revoke certificate',
        revokeCertificateQuestion: 'Revoke your signed certificate generated on',
        revokeCertificateDescription:
          'Once you revoke an certificate, there is no going back. Please be certain before proceeding.',
        successRevoke: 'Certificate revoked successfully.',
        noCertificates: 'No certificates, please create and Upload.',
        downloadTitle: 'Download certificates',
        uploadTitle: 'Upload CSR',
        uploadDescription: 'Max file size 200mb. (.csr)',
      },
    },
    certificateGenerate: {
      text: {
        title: 'Generate certificate',
        description:
          "You need a Certificate Signing Request (CSR) to create your test certificate. If you don't already have a CSR for your organisation then please use the below commands to create one:",
        command1Text: 'Generate a new RSA private key',
        command2Text: 'Generate the X.509 Certificate',
        requirements: 'CSR requirements:',
        requirement1: 'commonName must be equal to username',
        requirement2: 'userEmail must be equal to user email',
        requirement3: 'the rest of the fields can be left blank, including the "Password" field',
        requirement4: 'for more information, see {0}',
      },
    },
    certificateItem: {
      buttons: {
        revoke: 'Revoke',
        download: 'Download',
      },
      text: {
        generatedOn: 'Generated on:',
        status: 'Status:',
      },
    },
    certificateUpload: {
      buttons: {
        upload: 'Upload CSR',
      },
    },
    certificateUploadFile: {
      buttons: {
        select: 'Select File',
      },
      text: {
        description: 'Drag and drop a file to upload',
      },
    },
    footerContainer: {
      text: {
        subscriptionTitle: 'Newsletter',
        termOfUseLink: 'Terms',
        legalsLink: 'Legals',
        privacyPolicyLink: 'Privacy',
        CookiePolicyLink: 'Cookies',
        ManageCookieLink: 'Manage Cookie',
        status: 'Status',
        license: '© Staq Technologies LTD',
      },
    },
    subscription: {
      buttons: {
        submit: 'submit',
      },
      text: {
        success: 'Subscribed successfully!',
        // "error":"Subscribed successfully!",
        emailPlaceholder: 'Email address',
      },
    },
    footerList: {
      text: {
        contact: 'CONTACT',
        demo: 'Book live demo',
        enquiries: 'General enquiries',
        socialIcons: 'ELSEWHERE',
        facebook: 'Facebook',
        github: 'GitHub',
        productsTitle: 'PRODUCTS',
        payments: 'Payments',
        cards: 'Cards',
        accounts: 'Accounts',
        identity: 'Identity',
        productsLending: 'Lending',
        authentication: 'Authentication',
        resources: 'RESOURCES',
        trustlessSDK: 'Trustless SDK’s',
        pricing: 'Pricing',
        platform: 'PLATFORM',
        features: 'Features',
        devPortal: 'Developer portal',
        SDK: 'SDK’s',
        docs: 'Documentation',
        cases: 'USE CASES',
        insuranse: 'Insurance',
        marketplace: 'Marketplace',
        gigEconomy: 'Gig Economy',
        bankingSolutions: 'Banking as a service',
        banking: 'Banking',
        travel: 'Travel',
        telecommunications: 'Telecommunications',
        healthcare: 'Healthcare',
        gaming: 'Gaming',
        neobanks: 'Neobanks',
        eCommerce: 'E-commerce',
        bnpl: 'Buy now pay later',
        whiteLabelApps: 'White label apps',
        developersTitle: 'DEVELOPERS',
        apiDocumentation: 'API Documentation',
        apiSDK: 'API SDK’s',
        faqs: 'FAQs',
        companyTitle: 'COMPANY',
        about: 'About',
        careers: 'Careers',
        partners: 'Partners',
        socialMediaTitle: 'SOCIAL MEDIA',
        linkedIn: 'LinkedIn',
        twitter: 'Twitter',
        solutions: 'Solutions',
        lending: 'Lending as a service',
        embedded: 'Embedded Financial Services',
      },
    },
    invalidPage: {
      text: {
        description: 'Page is no longer valid. Please return to previous action and try again.',
      },
    },
    landingPage: {
      apis: {
        text: {
          comingSoon: 'Coming soon',
          description:
            'Our API Products let you use approved customer data to create or enhance your digital products.',
        },
      },
      landingMainCard: {
        buttons: {
          signUp: 'Sign Up',
          signIn: 'Sign In',
        },
        text: {
          title: 'Staq developer portal',
          description:
            'Use Staq’s API platform to seamlessly integrate financial services into your digital products, access financial data, and generate new revenue streams.',
        },
      },
    },
    termOfUsePage: {
      errors: {
        savingTermAgreement: 'Error in saving term agreement. Contact Customer support.',
      },
      buttons: {
        back: 'Back',
        continue: 'Continue',
      },
      text: {
        title: 'Terms and Conditions of Use of Staq Developer Portal ({0})',
        agreed: 'I have read and accepted the Terms of Use',
        p1Title: 'Overview',
        p1: 'These terms and conditions of use govern your access to and use of Staq’s APIs by accessing ourAPIs through the {0} (the {1}). In these Terms of Use, {2} or {3} means Staq with whom you are contracting.',
        p1_0: '[https://developer.staq.io/]',
        p1_1: '"Site"',
        p1_2: '"Staq", "we", "our"',
        p1_3: '"us"',
        p11: 'Please read the Terms of Use carefully before you start to use the Site. By using the Site,you accept and agree to be bound and abide by these Terms of Use and our PrivacyPolicy, found at {0}, incorporated herein by reference. If you do not want to agree to these Terms of Use or the Privacy Policy, you must not access or use the Site.',
        p11_0: 'www.staq.io/privacy-policy',
        p12: 'You must comply with all of the Terms. If you are agreeing to these Terms not as an individual but on behalf of your organisation (e.g. a company), then "you" means your organisation and you are binding your organisation to these Terms of Use.',
        p13: 'This Terms of Use shall be read together with and constitute an integral part of the APILicense Agreement which is concluded between you and Staq, with which you are andwarrants to remain bound.',
        p14: 'Nothing under or in connection with the Terms of Use or your access to or use of our Sandbox or APIs shall constitute an offer or agreement that you will be granted access to either or both for production purposes. Production uses of our APIs will be subject to you first passing Staq’s requirements, which shall include (without limitation) information security and data use requirements, as well as you concluding the API License Agreement with Staq.',
        p15: 'Your use of the Site is non-exclusive. You acknowledge that Staq and other developers may develop products or services that may compete with or provide similar functionality to your API client.',
        p2Title: 'Definitions and Interpretation',
        p21: 'In these Terms of Use, the following definitions apply:',
        p21_a:
          '{0} means the application programme interfaces provided by Staq and made available on the Site.',
        p21_a_0: 'APIs',
        p21_b:
          '{0} means all information that you or us obtain as a result of entering into these terms which relates to:',
        p21_b_0: 'Confidential Information',
        p21_b_i:
          'the negotiations leading up to, and the provisions or subject matter of, these terms or any ancillary matter;',
        p21_b_ii:
          'the other party’s business, including but not limited to any information pertaining to product development and plans, proprietary concepts, technical and/or product-related documentation, marketing strategic, financial development plans and forecasts, systems, operations, reports, specifications, software, source code,object code, flow charts, databases, inventions, know-how, trade secrets, formulas,improvements, customer lists and any customer information, supplier lists and any supplier information, pricing, sales estimates, business plans, present or future business activities;',
        p21_b_iii:
          'any scripts, software, text, interfaces, data, source code, logos, videos, images, audio or video made available on the Site, including all API constitutes Staq’s Confidential Information.',
        p21_c:
          '{0} means Staq and its respective affiliates, subsidiaries,holding companies, officers, directors, employees, contractors, agents, representatives, successors and assigns.',
        p21_c_0: 'Staq Indemnified Persons',
        p21_d:
          '{0} patents, utility models, rights to inventions, copyright and related rights, moral rights, trademarks, service marks, business names and domain names, rights in get-up and trade dress, goodwill and the right to sue for passing off or unfair competition, rights in designs, rights in computer software, database rights, rights to use, and protect the confidentiality of, Confidential Information (including know-how and trade secrets) and all other intellectual property rights, in each case whether registered or unregistered and including all applications and rights to apply for and be granted, renewals or extensions of, and rights to claim priority from, such rights and all similar or equivalent rights or forms of protection which subsist or will subsist now or in the future in any part of the world.',
        p21_d_0: 'Intellectual Property Rights',
        p21_e: '{0} means any of the following:',
        p21_e_0: 'Prohibited Activity',
        p21_e_p1: 'criminal or tortious activity;',
        p21_e_p2:
          'systematic retrieval of data or other content to create or compile, directly or indirectly, a collection, compilation, database or directory without prior written permission from Staq;',
        p21_e_p3:
          'making any unauthorized use of Staq’s products, services and/or APIs including collecting usernames and/or email addresses of users by electronic or other means for the purpose of sending unsolicited emails, or creating user accounts by automated means or under false pretences;',
        p21_e_p4:
          'tricking, defrauding or misleading Staq and other users, especially in any attempt to learn sensitive account information such as passwords;',
        p21_e_p5:
          'engaging in any automated use of the Site, such as using any data mining, robots or similar data gathering and extraction tools;',
        p21_e_p6:
          'interfering with, disrupting, or creating an undue burden on the networks, service sand/or APIs provided by Staq',
        p21_e_p7:
          'using any information obtained from Staq’s products, services and/or APIs in order to harass, abuse, or harm another person; and/or',
        p21_e_p8:
          'using Staq’s products, services and/or APIs as part of any effort to compete with Staq or to provide services substantially similar to the services which it provides.',
        p21_f:
          '{0} means using Sandbox, to test an application and use relevant API materials to interact with an API, for which we have granted you access from time to time',
        p21_f_0: 'Purpose',
        p21_g: '{0} means [INSERT];',
        p21_g_0: 'Site',
        p21_h:
          '{0} means Staq’s testing environment which may contain Sandbox Data (as such term is defined below) and functionality to allow you to create, develop and test applications.',
        p21_h_0: 'Sandbox',
        p21_i:
          '{0} means the live, actual, correct, actionable or fake, masked, obfuscated,encrypted and/or otherwise incorrect or in-actionable test data provided through theSandbox for use by or in the development of an application.',
        p21_i_0: 'Sandbox Data',
        p21_j: '{0} means these terms and conditions of use; and',
        p21_j_0: 'Terms of Use',
        p21_k:
          'You or you means the person accessing this Site or using the APIs available on this Site.',
        p3Title: 'Use of Site',
        p31: 'Conditional upon your compliance with these Terms of Use, we grant you a limited, non-exclusive, non-transferable, non-sublicensable, non-assignable, revocable license to access and use the Site solely for the purposes of testing and integrating the APIs with your system and services.',
        p32: 'Staq reserves all rights not expressly granted herein. This license does not include or authorize, and you agree to refrain from:',
        p321: 'any resale or commercial use of the Site or the content therein;',
        p322: 'the collection or use of any user listings, data, profiles, ratings, or descriptions;',
        p323: 'the distribution, public performance, or public display of any Site content;',
        p324: 'modifying or otherwise making any derivative uses of the Site, the Site content,or any portion thereof;',
        p325: 'use of any data mining, robots, or similar data gathering or extraction methods;',
        p326: 'downloading (other than the page caching) any portion of the Site, the Site content, or any information contained therein, except as expressly permitted on the Site;',
        p327: 'scraping, building databases or otherwise create copies of any information inorder to use such information for any purpose which does not relate to thePurpose;',
        p328: 'decompiling, disassembling, reverse engineering, or otherwise attempting to derive the source code for the Site or any software associated with the Site;',
        p329: 'altering or removing any copyright, trademark, or other protective notices contained in or on any portion of the Site; and/or',
        p3210:
          'using it in any shape, way or form in connection with a Prohibited Activity(and/or an attempted Prohibited Activity)',
        p33: 'Any use of the Site or any content therein, other than as specifically authorized herein, without the prior written permission of Staq, is strictly prohibited and will automatically terminate all licenses and/or rights granted herein.',
        p34: 'Staq may collect information about your use of the Sandbox and/or APIs. You agree to Staq collecting and using this information, and any other information you provide to us,for the purposes of carrying out our business, internal or external. This includes, without limitation, providing enhancements to the Sandbox APIs, or any other use as set out in any relevant Staq privacy notice or product terms.',
        p35: 'Staq would also like your feedback on the Sandbox and APIs. You agree that Staq may use, profit from, disclose, publish, or otherwise exploit any feedback you provide. Staq may use your feedback to modify the Sandbox or APIs at our discretion.',
        p4Title: 'Access',
        p41: 'In consideration of your use and access to the Site and only if Staq requests, you agree to:',
        p411: 'provide accurate, current, and complete information about you as may be prompted by any registration forms on the Site ({0});',
        p411_0: '"Registration Data"',
        p412: 'maintain the security of your password and identification;',
        p413: 'maintain and promptly update the Registration Data, and any other information you provide to Staq, to keep it accurate, current, and complete; and',
        p414: 'accept all risks of unauthorized access to the Registration Data and any other information you provide to Staq. In addition, you agree not to access, use, or attempt to access or use, the Site, any services provided using the identity or the Registration Data of any person other than you. If you know or suspect that anyone other than you knows your user name or password or any identification details relating to your organisation you must immediately notify us.',
        p5: 'In interfacing with the Site or an API available through it, you may access or otherwise use open source and/or third party software and for this purpose you agree that you have read and shall comply with any additional license terms we impose on you for each relevantAPI.',
        p51: 'Your use of any third-party links contained on this Site is at your own risk. We are not responsible for the content of any other websites or pages linked to or from this Site and have not verified the content of any such websites or pages.',
        p52: 'We may set and enforce limits on your use of the Sandbox or APIs (e.g. limiting the number of API requests that you may make or the number of users you may serve), at anytime. You must not attempt to circumvent such limitations, and you agree to use each of the Sandbox or APIs for reasonable volumes that are not excessive or abusive. If you would like to use any Sandbox or APIs beyond these limits, you must obtain Staq’s prior express written consent. Staq may decline such a request or set conditions on your use,or include additional terms for that use. To seek such approval, contact the relevant Staq team for information. If you do not agree to any conditions we impose, you must discontinue your use of that API or the Sandbox.',
        p53: 'You will ensure compliance with all applicable law in connection with your use of this Site and the APIs',
        p6Title: 'Indemnity',
        p61: 'You agree at all times, whether during or after termination or expiration of these Terms ofUse, at your sole cost and expense, to defend, indemnify and keep indemnified and hold the Staq Indemnified Persons harmless against any and all claims, losses, liabilities,damages, costs, or expenses from all lawsuits or causes of action incurred by or awarded or made against any Staq Indemnified Person or which are agreed by a Staq IndemnifiedPerson to be paid by way of settlement or compromise arising out of any claim relating to your breach or other actions or omissions in connection with these Terms of Use or use of the Site whether or not such losses were foreseeable.',
        p7Title: 'No Warranties',
        p71: 'To the fullest extent permitted by law, and unless expressly set out to the contrary in these Terms of Use:',
        p711: 'all warranties and terms which would otherwise be implied by law, custom or usage are excluded from these Terms of Use.',
        p712: 'all access to this Site and the APIs are made available to you on an "as is" and "as available" basis. We may suspend your access to, or suspend withdraw,discontinue or change, all or any of the Site or the APIs at any time without notice.',
        p713: 'we make no representations, warranties or guarantees, whether express or implied that this Site or the APIs (including any data obtained through the APIs)is accurate, lacks viruses, complete or up-to-date and that the Site will meet your requirements or that the Site will provide uninterrupted, timely, secure, or error free use. Your use of this Site is at your own risk, and you are solely responsible for all damages that result from your use of this Site.',
        p8Title: 'Limitation of Liability',
        p81: 'In no event will Staq, its affiliates, officers, agents, employees, licensors or any other related parties be liable for any indirect, incidental, special, consequential, or punitive damages in connection with or arising out of this agreement or your use of the Site, even if Staq has been advised of the possibility of such damages. In no event will Staq’s liability to you, whether in contract, tort (including negligence), or otherwise exceed (USD500]',
        p9Title: 'Confidentiality',
        p91: 'You must keep any Confidential Information we make available to you confidential and not disclose it to any third party and ensure that any representatives or other persons to whom you are permitted by these Terms of Use to provide access does the same. You must take all reasonable precautions and necessary steps to keep such ConfidentialInformation secure against theft or unauthorised access.',
        p92: 'Both Staq and you may disclose or allow disclosure of each other’s ConfidentialInformation:',
        p921: 'when disclosure is required by Law or the rules or order of any court, tribunal or agency of competent jurisdiction;',
        p922: 'to the extent that each other’s Confidential Information has become publicly available or generally known to the public at the time of the disclosure other than as a result of a breach of these Terms; or',
        p923: 'if given prior written approval to disclose the Confidential Information.',
        p93: 'Both Staq and you may disclose each other’s Confidential Information to our officers,employees or professional advisers to the extent necessary to enable us to perform or enforce any of our duties or rights under these Terms.',
        p94: 'The duties in this section shall continue to apply after these Terms end without limit in time.',
        p10Title: 'Intellectual Property Protection',
        p_11: 'We are the owner or licensee of all Intellectual Property Rights subsisting in the APIs and this Site. We (or our licensors) reserve all rights in and to the APIs and this Site.',
        p_12: 'All copyrights, save as expressly granted, are reserved in relation to any copyright on theSite, which may be owned or licensed by us. Unless otherwise indicated, copyright may not be used, sold, licensed copied or reproduced in whole or in part in any manner or form by any person without the prior written consent of Staq',
        p_13: 'Staq’s logo, slogan, or any other source-identifying information (the {0}) are trademarks of Staq. No third party shall use these Marks, or any other trademarks,slogans, or logos which are likely to cause confusion with Staq’s Marks, to mislead consumers about the origin of the third party’s goods or services, or to signal Staq‘s affiliation with, or sponsorship of, such third party’s products, services, websites, or companies. Additionally, Staq strictly forbids the use of "frames", framing techniques,meta tags, or any other "hidden text" utilizing the Marks. You agree you will not delete orin any manner alter the trademark notices or markings appearing on the Marks.',
        p_13_0: '"Marks"',
        p14Title: 'Security and Cyber Fraud Prevention',
        p141: 'on becoming aware of any event which has compromised or may have comprised the security or integrity of the Sandbox or APIs or our servers, systems or networks providing the Sandbox or APIs, or any of our data or confidential information, or your password, APIkey or access details ("{0}") you must:',
        p141_0: 'Security Risk',
        p141_i:
          'immediately notify Staq of the Security Risk and provide such details as Staq reasonably requires in order to respond to the Security Risk (including by promptly providing Staq with system logs in your possession or control); and',
        p141_ii:
          'provide all assistance reasonably requested by Staq to respond to and protect against or prevent the occurrence of the Security Risk including, without limitation, by taking measures to prevent the installation of your API Client on devices that have had their inbuilt security controls compromised (i.e.jail broken devices) noting that events which are in scope for attacking customer account credentials/authentication include phishing sites, malware attacks, especially trojans, or other means of criminal compromise of userdata;',
        p141_iii:
          'take reasonable care in the use of your password, API key and access details.For example, you must not disclose your password and/or your API key to any other person;',
        p141_iv:
          'ensure that your API client is developed in accordance with and addresses therisks described in, the {0} ("The Ten Most Critical WebApplication Security Risks"); and',
        p141_iv_0: 'OWASP Top 10 – 2017 rc1',
        p141_v:
          'provide to Staq a security attestation in the form and at such frequency as we may require from time to time',
        p142: 'Any failure by you to adhere to the above will entitle Staq to terminate the use of the Site and/or APIs and/or Sandbox immediately and without notice to you.',
        pLastTitle: 'Suspension & Termination',
        pWithCause: 'With Cause:',
        pWithCause_l:
          'We may suspend your access to the Site or terminate these Terms of Use at any time and with immediate effect if in our sole discretion:',
        pWithCause_l_i:
          'you are in breach of any of the terms and conditions of these Terms of Use;',
        pWithCause_l_ii:
          'you suffer a security breach that impacts on the confidentiality or integrity of this Site; or',
        pWithCause_l_iii: 'we have a legitimate concern about your use of this Site.',
        pWithoutCause: 'Without Cause:',
        pWithoutCause_m:
          'Both you and us may terminate these Terms without cause by giving not less than thirty(30) days’ written notice to the other party.',
        pWithoutCause_general: 'General',
        pWithoutCause_n:
          '{0} These Terms of Use take effect when you sign up for an account and accept these Terms of Use and will continue until terminated.',
        pWithoutCause_n_0: 'Term:',
        pWithoutCause_o:
          '{0} Nothing in, and no action taken under, these Terms of Use creates a relationship of principal and agent between any of the you and Staq or otherwise authorises you to bind Staq.',
        pWithoutCause_o_0: 'Relationship:',
        pWithoutCause_p:
          '{0} you may not assign, transfer or permit the exercise by any other party of your rights under these Terms of Use. We may subcontract, assign or novate these Terms of Use or any of our rights to any member of Staq’s group or third party.',
        pWithoutCause_p_0: 'Assignment:',
        pWithoutCause_q:
          '{0} We may revise and update these Terms of Use from time to time at our sole discretion. We will give you notice of these changes by posting an updated version of the Terms on the Site. By continuing to use the Site, you agree to be bound by the new Terms',
        pWithoutCause_q_0: 'Changes to the Terms of Use:',
        pWithoutCause_forceMaj:
          '{0} We are not liable for delay in performing, or failure toperform, any of our obligations under these Terms of Use if such delay or failure result from events, circumstances or causes beyond our reasonable control.',
        pWithoutCause_forceMaj_0: 'Force Majeure:',
        pWithoutCause_r:
          '{0} These Terms of Use, together with the documents referred to in it,constitutes the entire agreement and understanding between the parties in respect of the matters dealt with in it and supersedes any previous agreement between the parties in relation to such matters. If any provision of the Terms of Use becomes invalid, illegal,void, or unenforceable under any applicable law, each such provision shall be deemedamended to conform to applicable law; or, if it cannot be amended without materially altering the terms of this Terms of Use, such provision shall be deleted. The failure of Staq to enforce any right or provision of this Terms of Use does not constitute a waiver of that right or a waiver of future enforcement.',
        pWithoutCause_r_0: 'Entire Agreement:',
        pWithoutCause_s:
          '{0} The Terms of Use are governed by and interpreted in accordance with the laws of the Hashemite Kingdom of Jordan and the courts of the above jurisdiction will have exclusive jurisdiction in respect of any dispute, which may arise.',
        pWithoutCause_s_0: 'Governing Law and Jurisdiction:',
        pContactsTitle: 'Contact Details',
        pHaveAnyQuestions:
          'If you have any questions, complaints, or any other reason to contact Staq, please contact us at:',
        pMail: '[hello@staq.io]',
        pTermsUpdatedOn: 'These Terms of Use were last updated on [March] 2021.',
      },
    },
    contact: {
      error: {
        exception: 'Something went wrong. Please try again later or the provided data is invalid.',
      },
      text: {
        title: 'Contact us',
        description:
          'Need more info? Reach out to our team anytime, we will be more than happy to answer any questions you might have',
        titleH2: 'Careers',
        descriptionPart1:
          'We’re always on the look out for talented new people to grow the Staq team. Find out more about who we are and what we do ',
        descriptionLinkPart2: 'here',
        descriptionPart3: 'and to apply for one of our open positions check out our careers page.',
        btnJoin: 'Join the team',
        titleH2Thank: 'Thank you',
        descriptionThank:
          'Thanks for getting in touch. A member of the Staq team will be in touch as soon as possible.',
        firstName: 'First name',
        lastName: 'Last name',
        workEmail: 'Work email',
        workPhone: 'Work phone',
        selectLabel: 'Country',
        textareaLabel: 'message',
        textarea: 'Please provide any other information you’d like us to help with...',
        submit: 'submit',
      },
    },
    about: {
      text: {
        titlePart1: 'POWERING',
        titlePart2: 'INNOVATION',
        description:
          'We’re dedicated to building a platform that will connect consumers, developers, entrepreneurs and financial institutions. No suits and ties. No complexity. No limits. Just a world of endless opportunities.',
        descriptionInfo:
          'We’re an ambitious group of creative technologists, developers, engineers and problem solvers from all walks of life. Our eclectic backgrounds and interests allow us to approach traditional problems from fresh perspectives, creating truly unique products that will have a transformative impact on your business.',
        titleH2: 'Who we are',
        titleH2Bank: 'Want to build the future of banking?',
        btnJoin: 'Join the team',
        titleH3: 'Our story',
        story1:
          'Staq began life as the internal tech team at Bank al Etihad, the fastest growing bank in Jordan. We spent the past few years working relentlessly to completely overhaul the bank’s digital infrastructure and consumer products, transforming it into the market leading digital bank in Jordan.',
        story2:
          'Today we’re a fintech company (with a full banking license) based in Amman, with partners all over the globe. We have an array of ground-breaking digital products designed to empower the entrepreneurs of tomorrow, and we’re just getting started.',
      },
    },

    notFound: {
      button: {
        homepage: 'Homepage',
      },
      text: {
        title: 'Oops!',
        notPage: '404: The page was not found.',
        visit: 'Visit our homepage to start over',
      },
    },
    apiConsoleContainer: {
      errors: {
        sessionNotActive:
          'Your session has been terminated for security reasons. Please sign in again.',
      },
    },
  },
});

export default strings;
